import Layout from "./components/Layout.vue";
import Container from "./components/Container.vue";
import Slider from "./components/Slider.vue";

export default {
  install(Vue) {
    Vue.component("p-layout", Layout);
    Vue.component("p-container", Container); 
    Vue.component("d-slider", Slider);
  }
};
